module.exports = __webpack_public_path__ + "static/media/icon_144.670e2d62.svg";